import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation, HostListener, ViewChild, ElementRef } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'mapfre-auditlib-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss']
})
export class InputComponent implements OnInit {

  @Input()
  label

  @Input()
  placeholder

  @Input()
  inline

  @Input()
  type = "text"

  @Input()
  form: UntypedFormControl;

  @Input() icon;

  @Input() styleClass;

  @Input() skipHighlighter = false;

  _model;
  @Input()
  get model() {
    return this._model
  }
  set model(value) {
    this._model = value;
    this.modelChange.emit(this._model);
  }

  @Input() readonly;
  @Output()
  modelChange = new EventEmitter();

  @Input()
  buttonIcon;
  @Output()
  buttonClicked = new EventEmitter();

  @Output()
  blur = new EventEmitter();

  @ViewChild("inputRef", { static: false })
  private inputRef: ElementRef;

  constructor() { }

  ngOnInit() {
  }

  @HostListener('keydown.enter', ['$event'])
  onButtonClicked() {
    this.buttonClicked.emit();
    if (this.form) {
      this.form.markAsTouched();
    }
    this.onBlurHandler();
  }

  onBlurHandler() {
    this.blur.emit();
  }

  focus() {
    this.inputRef.nativeElement.focus();
    this.inputRef.nativeElement.click();
  }

}
